import * as XLSX from "xlsx-js-style";
import { buildInscripcionesWorksheet } from "./exportCongresoInscripcionesExcel";
import { buildContactosWorksheet } from "./exportCongresoContactosExcel";
import { buildTalleresInscripcionesWorksheet } from "./exportCongresoTalleresInscripcionesExcel";

function safeSheetName(name) {
  const cleaned = String(name || "Hoja")
    .replace(/[:\\/?*[\]]/g, " ")
    .trim();
  return (cleaned || "Hoja").slice(0, 31);
}

function excelDateStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
}

/**
 * Exporta un único .xlsx con varias hojas: inscripciones y formularios de la edición.
 * @param {{
 *   year?: number|string,
 *   finalizedGroups: object[],
 *   otherGroups: object[],
 *   contactosBySeccion: Array<{ key: string, title: string, rows: object[] }>,
 *   tallerRows?: object[],
 * }} params
 */
export function exportCongresoEdicionTodoExcel({
  year,
  finalizedGroups,
  otherGroups,
  contactosBySeccion,
  tallerRows,
}) {
  const wb = XLSX.utils.book_new();
  let sheetCount = 0;

  const append = (ws, name) => {
    if (!ws) return;
    XLSX.utils.book_append_sheet(wb, ws, safeSheetName(name));
    sheetCount += 1;
  };

  append(buildInscripcionesWorksheet(finalizedGroups), "Inscritos finalizados");
  append(buildInscripcionesWorksheet(otherGroups), "Inscritos otros");
  append(buildTalleresInscripcionesWorksheet(tallerRows), "Talleres");

  (contactosBySeccion || []).forEach((sec) => {
    const variant = sec.key === "envio" ? "envio" : "general";
    append(
      buildContactosWorksheet({ title: sec.title, rows: sec.rows, variant }),
      sec.title
    );
  });

  if (sheetCount === 0) return false;

  const y = year != null && year !== "" ? String(year) : "edicion";
  XLSX.writeFile(wb, `congreso-${y}-todo-${excelDateStamp()}.xlsx`);
  return true;
}
